import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-settings-icon',
    templateUrl: './settings-icon.component.html',
    styleUrls: ['./settings-icon.component.scss']
})
export class SettingsIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
